import {Content} from "pdfmake/interfaces";
import {primaryColor} from "../../../consts";
import {Color, ColorsItemsInterface} from "../../../../../store/types/store";
import {colorsNames} from "../../../../../hooks/useColors";
import {allPrices} from "../../../../../hooks";
import {useStoreRoom} from "../../../../../store";


export const getColorsBlock = (colorsItems: ColorsItemsInterface): Content => {
    const content: Content = []
    const hasTireRacks = useStoreRoom.getState().tireRacks.length > 0
    const colorEntries = Object.entries(colorsItems).filter(
        ([colorItem]) => colorItem !== "tireRacks" || hasTireRacks
    )

    content.push({text: '', marginTop: 10})
    colorEntries.forEach(([colorItem, color], index, arr) => {
        const isLastItem = arr.length - 1 === index
        content.push(getColorsWithTotalPrice(
            colorItem as keyof ColorsItemsInterface,
            colorsNames[color as Color],
            isLastItem ? allPrices.totalPrice : undefined
        ))
    })
    return content
}

const getColorsWithTotalPrice = (item: keyof ColorsItemsInterface, colorName: string, totalPrice?: number): Content => {
    let itemLabel = ''
    switch (item) {
        case 'guides':
            itemLabel = 'Направляющие (вертикали и горизонтали)'
            break;
        case "brackets":
            itemLabel = 'Кронштейны'
            break;
        case "perfpanels":
            itemLabel = 'Перфпанели и планки'
            break;
        case "shelves":
            itemLabel = 'Полки'
            break;
        case "tireRacks":
            itemLabel = 'Стеллажи для колес'
            break;
    }

    return ({
        color: primaryColor,
        margin: [20, 0, 20, 0],
        table: {
            widths: ['auto', '*'],
            body: [
                [
                    {
                        border: [false, false, false, false],
                        text: `${itemLabel}: ${colorName}`,
                        margin: [0, 0, 0, 0],
                        fontSize: 14,
                    },
                    {
                        border: [false, false, false, false],
                        margin: [0, 0, 0, 0],
                        characterSpacing: 1,
                        text: totalPrice ? `Сумма итого (Р): ${totalPrice.toLocaleString('ru')}` : '',
                        noWrap: true,
                        alignment: 'right',
                        fontSize: 14,
                        bold: true
                    }
                ],
            ]
        }
    })
}
